import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AccountWatermarkTemplates, HasSessionBasedTemplates } from '../../fragments/generated/watermark_templates';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountWatermarkTemplatesQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetAccountWatermarkTemplatesQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, hasSessionBasedTemplates?: boolean | null, watermarkTemplates?: { __typename?: 'WatermarkTemplateConnection', totalCount: number, nodes: Array<{ __typename?: 'WatermarkTemplate', id: string, deletedAt?: string | null, inUse: boolean, name: string, blocks?: Array<{ __typename?: 'WatermarkBlock', alpha?: number | null, fontSize?: Types.WatermarkFontSize | null, name?: string | null, position?: Types.WatermarkPosition | null, positionReferencePoint?: Types.WatermarkPosition | null, positionX?: number | null, positionY?: number | null, rotation?: number | null, scrollText?: Types.WatermarkScrollText | null, textAlignment?: Types.WatermarkTextAlignment | null, textColor?: string | null, textShadow?: boolean | null, dataPoints?: Array<{ __typename?: 'WatermarkDataPointCustomText', value?: string | null } | { __typename: 'WatermarkDataPointEmail' } | { __typename: 'WatermarkDataPointIpAddress' } | { __typename: 'WatermarkDataPointTimestamp' } | { __typename: 'WatermarkDataPointUserInput' } | { __typename: 'WatermarkDataPointUserName' } | null> | null } | null> | null }> } | null } | null };


export const GetAccountWatermarkTemplates = /*#__PURE__*/ gql`
    query GetAccountWatermarkTemplates($accountId: ID!) {
  account(accountId: $accountId) {
    id
    ...HasSessionBasedTemplates
    ...AccountWatermarkTemplates
  }
}
    ${HasSessionBasedTemplates}
${AccountWatermarkTemplates}` as unknown as DocumentNode<GetAccountWatermarkTemplatesQuery, GetAccountWatermarkTemplatesQueryVariables>;

          

          export const useGetAccountWatermarkTemplatesQuery = (options?:QueryHookOptions<GetAccountWatermarkTemplatesQuery, GetAccountWatermarkTemplatesQueryVariables>) => useQuery(GetAccountWatermarkTemplates, options);

          

          export type GetAccountWatermarkTemplatesQueryOptions = QueryHookOptions<GetAccountWatermarkTemplatesQuery, GetAccountWatermarkTemplatesQueryVariables>;

          

          export const useGetAccountWatermarkTemplatesLazyQuery = (options?:LazyQueryHookOptions<GetAccountWatermarkTemplatesQuery, GetAccountWatermarkTemplatesQueryVariables>) => useLazyQuery(GetAccountWatermarkTemplates, options);

          

          export type GetAccountWatermarkTemplatesQueryResult = ReturnType<typeof useGetAccountWatermarkTemplatesQuery>;

          
